import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainerReport,
    GridContainerReportResumo,
    GridItem2,
    GridItem4,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    DivOverflowXTabelaPadrao,
} from '../../../business-components/Div/Div'

import {
    CardGridEstudo,
    CardGridDivHeaderResumoCabecalho,
    CardGridDivBodyResumo,
    CardGridDivBodyResumoTotal,
    CardGridDivBodyResumoTotalGeral,
} from '../../../business-components/Card/Card'

import {
    formataReportTituloColuna,
    formataReportTituloLinha,
    formataReportTituloLinhaTotal,
    formataReportValor,
    formataReportValorTotal,
} from '../../../business-components/Formata/Formata'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadraoMd,
} from '../estudo-form/EstudoComp'

import EstudoReportResumoNecessidadeProtecaoPanel from './EstudoReportResumoNecessidadeProtecaoPanel'



const EstudoReportResumoNecessidadeProtecao = ({ values, estudo, report }) => {

    const GridItem2smDown2Right = (props) => { // mudança fonte: GridItem2smDown2Center
    
        return (
            <GridItem2
                align='right' // mudança fonte: 'center'
                {...props}
            />
        )
    }

    const GridItem2smDown2RightMt1 = (props) => { // mudança fonte: GridItem2smDown2CenterMt1
    
        return (
            <GridItem2
                className="mt-1"
                align='right' // mudança fonte: 'center'
                {...props}
            />
        )
    }

    const ResumoNecessidadeProtecao = () => {

        return (
            <div
                align='left'
            >
                {/*report && (
                    <br/>
                ) mudança da fonte*/}

                
                <GridItem12>
                    <CardGridEstudo>
                        <CardGridDivHeaderResumoCabecalho>
                            <GridContainerReport>
                                <GridItem4>
                                    {
                                        formataReportTituloColuna('')
                                    }
                                </GridItem4>
                                <GridItem2smDown2Right/>
                                {dadosCompletosCliente(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportTituloColuna(tituloCliente(values))
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                {dadosCompletosConjuge(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportTituloColuna(tituloConjuge(values))
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                <GridItem2smDown2Right>
                                    {
                                        formataReportTituloColuna(LABEL.anosProteger)
                                    }
                                </GridItem2smDown2Right>
                            </GridContainerReport>
                        </CardGridDivHeaderResumoCabecalho>
                    </CardGridEstudo>
                </GridItem12>

                <GridItem12
                    className='mt-8'
                >
                    <CardGridDivBodyResumoTotalGeral>
                        <GridContainerReportResumo>
                            <GridItem6>
                                {
                                    formataReportTituloLinhaTotal(LABEL.necessidadeProtecao.toUpperCase()) // mudança da fonte: uppercase
                                }
                            </GridItem6>
                            {dadosCompletosCliente(values) && (
                                <GridItem2smDown2RightMt1>
                                    {
                                        formataReportValorTotal(values.necessidadeProtecaoCliente)
                                    }
                                </GridItem2smDown2RightMt1>
                            )}
                            {dadosCompletosConjuge(values) && (
                                <GridItem2smDown2RightMt1>
                                    {
                                        formataReportValorTotal(values.necessidadeProtecaoConjuge)
                                    }
                                </GridItem2smDown2RightMt1>
                            )}
                            <GridItem2smDown2Right />
                        </GridContainerReportResumo>
                    </CardGridDivBodyResumoTotalGeral>
                </GridItem12>

                
                {/*values.morteInvalidezEstudo !== HARDCODE.morteInvalidezEstudoInvalidez && ( => retirado quando tratou "Estava gerando erro no gráfico da Projeção da Sucessão Vitalícia"*/}
                    <GridItem12
                        className='mt-8'
                    >
                        <CardGridDivBodyResumoTotal>
                            <GridContainerReportResumo>
                                <GridItem4>
                                    {
                                        formataReportTituloLinhaTotal(LABEL.sucessaoVitalicia.toUpperCase()) // mudança da fonte: uppercase
                                    }
                                </GridItem4>
                                <GridItem2smDown2Right />
                                {dadosCompletosCliente(values) && (
                                    <GridItem2smDown2RightMt1>
                                        {
                                            formataReportValorTotal(values.sucessaoVitaliciaCliente)
                                        }
                                    </GridItem2smDown2RightMt1>
                                )}
                                {dadosCompletosConjuge(values) && (
                                    <GridItem2smDown2RightMt1>
                                        {
                                            formataReportValorTotal(values.sucessaoVitaliciaConjuge)
                                        }
                                    </GridItem2smDown2RightMt1>
                                )}
                                <GridItem2smDown2Right />
                            </GridContainerReportResumo>
                        </CardGridDivBodyResumoTotal>

                        <CardGridDivBodyResumo
                            className='bg-cardGridDivBodyResumo mt-5'
                        >
                            <GridContainerReportResumo>
                                <GridItem4>
                                    {
                                        formataReportTituloLinha(LABEL.emergencial)
                                    }
                                </GridItem4>
                                <GridItem2smDown2Right />
                                {dadosCompletosCliente(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportValor(values.emergencialCliente)
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                {dadosCompletosConjuge(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportValor(values.emergencialConjuge)
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                <GridItem2smDown2Right />
                            </GridContainerReportResumo>
                        </CardGridDivBodyResumo>

                        <CardGridDivBodyResumo>
                            <GridContainerReportResumo>
                                <GridItem4>
                                    {
                                        formataReportTituloLinha(LABEL.inventario)
                                    }
                                </GridItem4>
                                <GridItem2smDown2Right />
                                {dadosCompletosConjuge(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportValor(values.inventarioCliente)
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                {dadosCompletosConjuge(values) && (
                                    <GridItem2smDown2Right>
                                        {
                                            formataReportValor(values.inventarioConjuge)
                                        }
                                    </GridItem2smDown2Right>
                                )}
                                <GridItem2smDown2Right />
                            </GridContainerReportResumo>
                        </CardGridDivBodyResumo>
                        
                        <br/>
                    </GridItem12>
                {/*})*/}

                <EstudoReportResumoNecessidadeProtecaoPanel
                    values={values}
                    panelValores={estudo.current.panelDespesasTotais}
                    tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                />
                
                <br/>

                <EstudoReportResumoNecessidadeProtecaoPanel
                    values={values}
                    panelValores={estudo.current.panelGarantiasAtuais}
                    tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                />
            </div>
        )
    }

    return (
        <GridItem12>
            {report || relatorioModoApresentacao(values)
                ?
                    <ResumoNecessidadeProtecao/>
                :
                    <CardGridEstudoPadraoMd
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.necessidadeProtecao
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <DivOverflowXTabelaPadrao>
                                <ResumoNecessidadeProtecao/>
                            </DivOverflowXTabelaPadrao>
                        }
                        overflowX={false}
                        modoApresentacao={values.modoApresentacao}
                    />
            }
        </GridItem12>
    )
}

export default EstudoReportResumoNecessidadeProtecao